/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFrame = createReactComponent("frame", "IconFrame", [
  ["path", { d: "M4 7l16 0", key: "svg-0" }],
  ["path", { d: "M4 17l16 0", key: "svg-1" }],
  ["path", { d: "M7 4l0 16", key: "svg-2" }],
  ["path", { d: "M17 4l0 16", key: "svg-3" }]
]);

export { IconFrame as default };
//# sourceMappingURL=IconFrame.js.map
